const thorThunder = "thor-thunder";
const dracoMight = "draco-might";
const mermaidHaven = "mermaid-haven";
const zephirBlade = "zephir-blade";

export const SERVER_DOMAINS: Record<Brand, string> = {
  [thorThunder]: window.location.host.split(".")[1],
  [dracoMight]: "gcmforex",
  [mermaidHaven]: "",
  [zephirBlade]: window.location.host.split(".")[1],
};

export const BRANDS = [
  thorThunder,
  dracoMight,
  mermaidHaven,
  zephirBlade,
] as const;

export type Brand = (typeof BRANDS)[number];
